import React, { useState } from 'react'
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';

function Contact() {
    const API_URL = process.env.REACT_APP_API_URL;
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        email: "",
        subject: "",
        message: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch(`${API_URL}/email/contactForm`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',  // Specify the content type
                },
                body: JSON.stringify(formData),
            })

            const result = await response.json()

            if (result.data === true) {
                toast.success(`Успешно ја испративте Вашата порака. Ви благодариме!`);
                setFormData({
                    email: "",
                    subject: "",
                    message: "",
                })
                setLoading(false);
            }
            else {
                setLoading(false);
                toast.warning(`Настана проблем при испраќањето на пораката. Ве молиме пишете ни на 074 22 95 95.`);
            }

        } catch (error) {
            toast.warning(`Настана проблем при испраќањето на пораката. Ве молиме пишете ни на 074 22 95 95.`);
        }
    };

    return (
        <div>
            <Helmet>
                <title>Контакт | Онлајн продавница за масла, филтри, авто делови и адитиви.</title>
                <meta name="description" content="Контактирајте не за сите прашања поврзани со масла, филтри, адитиви и авто делови. Тука сме да ви помогнеме!" />
                <meta name="keywords" content="контакт, авто делови, мала сервис, масла за кола, уље, филтри, адитиви, поддршка" />
            </Helmet>
            <section className="bg-white dark:bg-gray-900">
                <div className="py-8 lg:py-16 px-4 mx-auto max-w-screen-md">
                    <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-center text-gray-900 dark:text-white">
                        Контакт
                    </h2>
                    <form onSubmit={handleSubmit} className="space-y-8">
                        <div>
                            <label
                                htmlFor="email"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Вашиот емаил
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                                placeholder="Внесете емаил"
                                required
                                disabled={loading}
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="subject"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                            >
                                Наслов
                            </label>
                            <input
                                type="text"
                                id="subject"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                className="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                                placeholder="Како можеме да ви помогнеме?"
                                required
                                disabled={loading}
                            />
                        </div>
                        <div className="sm:col-span-2">
                            <label
                                htmlFor="message"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
                            >
                                Вашата порака
                            </label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                rows="6"
                                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                placeholder="Оставете коментар..."
                                disabled={loading}
                            ></textarea>
                        </div>
                        <button
                            type="submit"
                            className="btn btn-secondary py-3 px-5"
                            disabled={loading}
                        >
                            Испрати
                        </button>
                    </form>
                </div>
            </section>
        </div>
    )
}

export default Contact
